import React, { useState } from 'react'
import Grid from '@mui/material/Grid2';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight } from '@fortawesome/free-solid-svg-icons';
import ValidateCats from '../../../../components/common/ValidateCats';
// import { toast } from 'react-toastify';
// import { apiService } from '../../../../services/apiService';
function ImmigrationHistory() {
    // const { requestId } = useParams();
    // const roles = localStorage.getItem('role');
    const navigate = useNavigate();
    const [isVisible, setIsVisible] = useState(true);
    const toggleVisibility = () => {
        setIsVisible(!isVisible);
      };
      const closeElement = () => {
        setIsVisible(true);
      };
  
  return (
    <div className='container-fluid px-0'>
        <div className={isVisible ? 'hide_mobitr' : 'show_mobitr'}>
            <ValidateCats onClose={closeElement}/>
        </div>
        <div className='content_container_validate' style={{ flexGrow: 1 }}>
            <Grid size={{md:12,xs:12}} container flexDirection="column" className="jobseekerhead mb-3">
                <span><b onClick={()=>navigate("/dashboard")}>Dashboard</b> <FontAwesomeIcon className='angleright' icon={faAngleRight} /> Case10000</span>
            </Grid>
            <Grid size={{sm:12}} container className="main_jobseeker">
                <Grid size={{sm:12}} container alignItems="center">
                    <Grid size={{md:12,xs:12}} container flexDirection="column" className="jobseekerhead border_botomer">
                        <h3>Immigration History
                            <select>
                                <option value="">In Progress</option>
                                <option value="">In Progress</option>
                                <option value="">In Progress</option>
                                <option value="">In Progress</option>
                            </select>
                        </h3>
                        <b>Jobseeker Name</b>
                        <button onClick={toggleVisibility} className='d-md-none main_category_btn'>
                            List
                        </button>
                    </Grid>
                    <Grid size={{xs:12}} container justifyContent="flex-start" className="statusselectbtn mt-4">
                        <div className='knowledgetab_btnredirect'>
                            <button className="active_tabbtn">Overview</button>
                            <button>Assignments</button>
                            <button>Discussions</button>
                            <button>Knowledge</button>
                            <button>History</button>
                        </div>
                    </Grid>
                    <form className='w-100 mt-3' 
                        // onSubmit={handleSubmit}
                        >
                        {/* <Grid size={{sm:12, xs:12}} container justifyContent="flex-end" className="mt-2">
                            <button type='submit' className='registersendbtn2 mb-0'>{submitloader ? <img src={require('../../../assets/whiteloader.gif')} alt=''/> : 'Send Request'}</button>
                        </Grid> */}
                        
                        <Grid size={{lg:12,xs:12}} container justifyContent="space-between" className="regiter_inputs i94validateinput">
                            <Grid size={{md:12,xs:12}} container flexDirection="column" className="jobseekerhead pt-4 pb-0 border_botomer">
                                <h3>General</h3>
                            </Grid>
                            <Grid size={{xs:12}} container  flexDirection="column">
                                <span>Do you currently have any pending visa applications or petitions with USCIS ?<small>*</small></span>
                                <div className='d-flex align-items-center main_radioregister'>
                                    <input
                                        type="radio" 
                                        name="laws_and_regulations"
                                        // checked={formData.laws_and_regulations} 
                                        // onChange={handleInputChange} 
                                    />Yes
                                    <input
                                        type="radio" 
                                        name="laws_and_regulations"
                                        // checked={formData.laws_and_regulations} 
                                        // onChange={handleInputChange} 
                                    />No
                                </div>
                                {/* {errors.laws_and_regulations && <p style={{color:"Red"}}>{errors.laws_and_regulations}</p>} */}
                            </Grid>
                            <Grid size={{xs:12}} container  flexDirection="column">
                                <span>Have you experienced the issue of Requests for evidence (RFE) ?<small>*</small></span>
                                <div className='d-flex align-items-center main_radioregister'>
                                    <input
                                        type="radio" 
                                        name="laws_and_regulations"
                                        // checked={formData.laws_and_regulations} 
                                        // onChange={handleInputChange} 
                                    />Yes
                                    <input
                                        type="radio" 
                                        name="laws_and_regulations"
                                        // checked={formData.laws_and_regulations} 
                                        // onChange={handleInputChange} 
                                    />No
                                </div>
                                {/* {errors.laws_and_regulations && <p style={{color:"Red"}}>{errors.laws_and_regulations}</p>} */}
                            </Grid>
                            <Grid size={{xs:12}} container  flexDirection="column">
                                <span>Have you ever faced any legal issues related to your immigration status (e.g., overstays, unauthorized employment) ?<small>*</small></span>
                                <div className='d-flex align-items-center main_radioregister'>
                                    <input
                                        type="radio" 
                                        name="laws_and_regulations"
                                        // checked={formData.laws_and_regulations} 
                                        // onChange={handleInputChange} 
                                    />Yes
                                    <input
                                        type="radio" 
                                        name="laws_and_regulations"
                                        // checked={formData.laws_and_regulations} 
                                        // onChange={handleInputChange} 
                                    />No
                                </div>
                                {/* {errors.laws_and_regulations && <p style={{color:"Red"}}>{errors.laws_and_regulations}</p>} */}
                            </Grid>
                            <Grid size={{xs:12}} container  flexDirection="column">
                                <span>Have you ever had any visa petitions denied or revoked ?<small>*</small></span>
                                <div className='d-flex align-items-center main_radioregister'>
                                    <input
                                        type="radio" 
                                        name="laws_and_regulations"
                                        // checked={formData.laws_and_regulations} 
                                        // onChange={handleInputChange} 
                                    />Yes
                                    <input
                                        type="radio" 
                                        name="laws_and_regulations"
                                        // checked={formData.laws_and_regulations} 
                                        // onChange={handleInputChange} 
                                    />No
                                </div>
                                {/* {errors.laws_and_regulations && <p style={{color:"Red"}}>{errors.laws_and_regulations}</p>} */}
                            </Grid>
                            <Grid size={{xs:12}} container  flexDirection="column">
                                <span>Have you ever faced any legal issues related to your immigration status (e.g., overstays, unauthorized employment) ?<small>*</small></span>
                                <div className='d-flex align-items-center main_radioregister'>
                                    <input
                                        type="radio" 
                                        name="laws_and_regulations"
                                        // checked={formData.laws_and_regulations} 
                                        // onChange={handleInputChange} 
                                    />Yes
                                    <input
                                        type="radio" 
                                        name="laws_and_regulations"
                                        // checked={formData.laws_and_regulations} 
                                        // onChange={handleInputChange} 
                                    />No
                                </div>
                                {/* {errors.laws_and_regulations && <p style={{color:"Red"}}>{errors.laws_and_regulations}</p>} */}
                            </Grid>
                            <Grid size={{xs:12}} container  flexDirection="column">
                                <span>Are you aware of any current or upcoming changes in your visa status that may affect your ability to work in the U.S. ?<small>*</small></span>
                                <div className='d-flex align-items-center main_radioregister'>
                                    <input
                                        type="radio" 
                                        name="laws_and_regulations"
                                        // checked={formData.laws_and_regulations} 
                                        // onChange={handleInputChange} 
                                    />Yes
                                    <input
                                        type="radio" 
                                        name="laws_and_regulations"
                                        // checked={formData.laws_and_regulations} 
                                        // onChange={handleInputChange} 
                                    />No
                                </div>
                                {/* {errors.laws_and_regulations && <p style={{color:"Red"}}>{errors.laws_and_regulations}</p>} */}
                            </Grid>
                            <Grid size={{xs:12}} container flexDirection="column" className="coustom_textarea">
                                <span>Please explain the upcoming changes in your visa status ?</span>
                                <textarea placeholder='Describe'/>
                                {/* {errors.gender && <p style={{color:"Red"}}>{errors.gender[0]}</p>} */}
                            </Grid>
                            <Grid size={{md:12,xs:12}} container flexDirection="column" className="jobseekerhead pt-4 pb-0 border_botomer">
                                <h3>Consulate and Port of entry Issues</h3>
                            </Grid>
                            <Grid size={{xs:12}} container  flexDirection="column">
                                <span>Have you experienced the issue of 221g during visa stamping ?<small>*</small></span>
                                <div className='d-flex align-items-center main_radioregister'>
                                    <input
                                        type="radio" 
                                        name="laws_and_regulations"
                                        // checked={formData.laws_and_regulations} 
                                        // onChange={handleInputChange} 
                                    />Yes
                                    <input
                                        type="radio" 
                                        name="laws_and_regulations"
                                        // checked={formData.laws_and_regulations} 
                                        // onChange={handleInputChange} 
                                    />No
                                </div>
                                {/* {errors.laws_and_regulations && <p style={{color:"Red"}}>{errors.laws_and_regulations}</p>} */}
                            </Grid>
                            <Grid size={{xs:12}} container  flexDirection="column">
                                <span>Have you experienced a interrogation with CBP officer at any US Port of entry (Airports, Waterways, Roadways)<small>*</small></span>
                                <div className='d-flex align-items-center main_radioregister'>
                                    <input
                                        type="radio" 
                                        name="laws_and_regulations"
                                        // checked={formData.laws_and_regulations} 
                                        // onChange={handleInputChange} 
                                    />Yes
                                    <input
                                        type="radio" 
                                        name="laws_and_regulations"
                                        // checked={formData.laws_and_regulations} 
                                        // onChange={handleInputChange} 
                                    />No
                                </div>
                                {/* {errors.laws_and_regulations && <p style={{color:"Red"}}>{errors.laws_and_regulations}</p>} */}
                            </Grid>
                            <Grid size={{md:12,xs:12}} container flexDirection="column" className="jobseekerhead pt-4 pb-0 border_botomer">
                                <h3>Legal issues in the past</h3>
                            </Grid>
                            <Grid size={{xs:12}} container  flexDirection="column">
                                <span>Do you have any current or past legal disputes with any employers regarding your immigration status or visa sponsorship ?<small>*</small></span>
                                <div className='d-flex align-items-center main_radioregister'>
                                    <input
                                        type="radio" 
                                        name="laws_and_regulations"
                                        // checked={formData.laws_and_regulations} 
                                        // onChange={handleInputChange} 
                                    />Yes
                                    <input
                                        type="radio" 
                                        name="laws_and_regulations"
                                        // checked={formData.laws_and_regulations} 
                                        // onChange={handleInputChange} 
                                    />No
                                </div>
                                {/* {errors.laws_and_regulations && <p style={{color:"Red"}}>{errors.laws_and_regulations}</p>} */}
                            </Grid>
                            <Grid size={{xs:12}} container  flexDirection="column">
                                <span>Have you ever worked for an employer who was involved in any legal issues related to immigration or employment practices?<small>*</small></span>
                                <div className='d-flex align-items-center main_radioregister'>
                                    <input
                                        type="radio" 
                                        name="laws_and_regulations"
                                        // checked={formData.laws_and_regulations} 
                                        // onChange={handleInputChange} 
                                    />Yes
                                    <input
                                        type="radio" 
                                        name="laws_and_regulations"
                                        // checked={formData.laws_and_regulations} 
                                        // onChange={handleInputChange} 
                                    />No
                                </div>
                                {/* {errors.laws_and_regulations && <p style={{color:"Red"}}>{errors.laws_and_regulations}</p>} */}
                            </Grid>
                            <Grid size={{xs:12}} container  flexDirection="column">
                                <span>Have you ever been employed by a company that has faced any legal action or investigation by USCIS, Department of Labor (DOL), or any other federal agency for visa-related violations ?<small>*</small></span>
                                <div className='d-flex align-items-center main_radioregister'>
                                    <input
                                        type="radio" 
                                        name="laws_and_regulations"
                                        // checked={formData.laws_and_regulations} 
                                        // onChange={handleInputChange} 
                                    />Yes
                                    <input
                                        type="radio" 
                                        name="laws_and_regulations"
                                        // checked={formData.laws_and_regulations} 
                                        // onChange={handleInputChange} 
                                    />No
                                </div>
                                {/* {errors.laws_and_regulations && <p style={{color:"Red"}}>{errors.laws_and_regulations}</p>} */}
                            </Grid>
                            <Grid size={{xs:12}} container  flexDirection="column">
                                <span>Were you ever informed by any of your previous employers that they were under investigation or facing legal challenges related to immigration practices?<small>*</small></span>
                                <div className='d-flex align-items-center main_radioregister'>
                                    <input
                                        type="radio" 
                                        name="laws_and_regulations"
                                        // checked={formData.laws_and_regulations} 
                                        // onChange={handleInputChange} 
                                    />Yes
                                    <input
                                        type="radio" 
                                        name="laws_and_regulations"
                                        // checked={formData.laws_and_regulations} 
                                        // onChange={handleInputChange} 
                                    />No
                                </div>
                                {/* {errors.laws_and_regulations && <p style={{color:"Red"}}>{errors.laws_and_regulations}</p>} */}
                            </Grid>
                            <Grid size={{md:12,xs:12}} container flexDirection="column" className="jobseekerhead pt-4 pb-0 border_botomer">
                                <h3>FDNS Site Visits</h3>
                            </Grid>
                            <Grid size={{xs:12}} container  flexDirection="column">
                                <span>Have you ever been involved in an FDNS site visit or audit at any of your previous employers ?<small>*</small></span>
                                <div className='d-flex align-items-center main_radioregister'>
                                    <input
                                        type="radio" 
                                        name="laws_and_regulations"
                                        // checked={formData.laws_and_regulations} 
                                        // onChange={handleInputChange} 
                                    />Yes
                                    <input
                                        type="radio" 
                                        name="laws_and_regulations"
                                        // checked={formData.laws_and_regulations} 
                                        // onChange={handleInputChange} 
                                    />No
                                </div>
                                {/* {errors.laws_and_regulations && <p style={{color:"Red"}}>{errors.laws_and_regulations}</p>} */}
                            </Grid>
                            <Grid size={{xs:12}} container  flexDirection="column">
                                <span>Have you ever been directly interviewed by an FDNS officer ?<small>*</small></span>
                                <div className='d-flex align-items-center main_radioregister'>
                                    <input
                                        type="radio" 
                                        name="laws_and_regulations"
                                        // checked={formData.laws_and_regulations} 
                                        // onChange={handleInputChange} 
                                    />Yes
                                    <input
                                        type="radio" 
                                        name="laws_and_regulations"
                                        // checked={formData.laws_and_regulations} 
                                        // onChange={handleInputChange} 
                                    />No
                                </div>
                                {/* {errors.laws_and_regulations && <p style={{color:"Red"}}>{errors.laws_and_regulations}</p>} */}
                            </Grid>
                            <Grid size={{xs:12}} container  flexDirection="column">
                                <span>Was your role, location, or project ever scrutinized during an FDNS site visit ?<small>*</small></span>
                                <div className='d-flex align-items-center main_radioregister'>
                                    <input
                                        type="radio" 
                                        name="laws_and_regulations"
                                        // checked={formData.laws_and_regulations} 
                                        // onChange={handleInputChange} 
                                    />Yes
                                    <input
                                        type="radio" 
                                        name="laws_and_regulations"
                                        // checked={formData.laws_and_regulations} 
                                        // onChange={handleInputChange} 
                                    />No
                                </div>
                                {/* {errors.laws_and_regulations && <p style={{color:"Red"}}>{errors.laws_and_regulations}</p>} */}
                            </Grid>
                            <Grid size={{md:12,xs:12}} container flexDirection="column" className="jobseekerhead pt-4 pb-0 border_botomer">
                                <h3>H1B Related Questions</h3>
                            </Grid>
                            <Grid size={{xs:12}} container  flexDirection="column">
                                <span>Have you ever had multiple H1B petitions filed on your behalf for the same fiscal year by different employers ?<small>*</small></span>
                                <div className='d-flex align-items-center main_radioregister'>
                                    <input
                                        type="radio" 
                                        name="laws_and_regulations"
                                        // checked={formData.laws_and_regulations} 
                                        // onChange={handleInputChange} 
                                    />Yes
                                    <input
                                        type="radio" 
                                        name="laws_and_regulations"
                                        // checked={formData.laws_and_regulations} 
                                        // onChange={handleInputChange} 
                                    />No
                                </div>
                                {/* {errors.laws_and_regulations && <p style={{color:"Red"}}>{errors.laws_and_regulations}</p>} */}
                            </Grid>
                            <Grid size={{xs:12}} container  flexDirection="column">
                                <span>Have you ever experienced an H1B petition withdrawal or revocation after the lottery due to suspected fraud or misrepresentation by the employer ?<small>*</small></span>
                                <div className='d-flex align-items-center main_radioregister'>
                                    <input
                                        type="radio" 
                                        name="laws_and_regulations"
                                        // checked={formData.laws_and_regulations} 
                                        // onChange={handleInputChange} 
                                    />Yes
                                    <input
                                        type="radio" 
                                        name="laws_and_regulations"
                                        // checked={formData.laws_and_regulations} 
                                        // onChange={handleInputChange} 
                                    />No
                                </div>
                                {/* {errors.laws_and_regulations && <p style={{color:"Red"}}>{errors.laws_and_regulations}</p>} */}
                            </Grid>
                            <Grid size={{xs:12}} container  flexDirection="column">
                                <span>Has your H1B visa ever been revoked or withdrawn by an employer ?<small>*</small></span>
                                <div className='d-flex align-items-center main_radioregister'>
                                    <input
                                        type="radio" 
                                        name="laws_and_regulations"
                                        // checked={formData.laws_and_regulations} 
                                        // onChange={handleInputChange} 
                                    />Yes
                                    <input
                                        type="radio" 
                                        name="laws_and_regulations"
                                        // checked={formData.laws_and_regulations} 
                                        // onChange={handleInputChange} 
                                    />No
                                </div>
                                {/* {errors.laws_and_regulations && <p style={{color:"Red"}}>{errors.laws_and_regulations}</p>} */}
                            </Grid>
                            <Grid size={{md:5.6,sm:5.8,xs:12}} container flexDirection="column">
                                <span>Upload Supporting Documents</span>
                                <div className="fileUploadInput">
                                    <input
                                        type="file"
                                        name="i94_copy"
                                        id="i94_copy"
                                        // onChange={handleFileChange}
                                        style={{ display: 'none' }} // Hide the actual file input
                                    />
                                    <label htmlFor="i94_copy" style={{ cursor: 'pointer' }}>Upload</label>
                                    <input
                                        type="text"
                                        // value={fileNames.i94_copy || ''}
                                        readOnly
                                        placeholder="No file chosen"
                                    />
                                </div>
                                {/* {errors.first_name && <p style={{color:"Red"}}>{errors.first_name[0]}</p>} */}
                            </Grid>
                            <Grid size={{xs:12}} container flexDirection="column" className="coustom_textarea">
                                <span>Comments</span>
                                <textarea placeholder='Describe'/>
                                {/* {errors.gender && <p style={{color:"Red"}}>{errors.gender[0]}</p>} */}
                            </Grid>
                            <Grid size={{sm:12, xs:12}} container className="mt-2 gap-5">
                                <button type='submit' className='registersendbtn2'>Save</button>
                                <button type='submit' className='registersendbtn1'>Cancel</button>
                                {/* <button type='submit' className='registersendbtn2'>{submitloader ? <img src={require('../../../assets/whiteloader.gif')} alt=''/> : 'Send Request'}</button> */}
                            </Grid>
                        </Grid>
                    </form>
                    <Grid size={{lg:12,xs:12}} container justifyContent="space-between" className="i94viewvalidate">
                        <Grid size={{md:12,xs:12}} container flexDirection="column" className="jobseekerhead pt-4 pb-0 border_botomer">
                            <h3>General</h3>
                        </Grid>
                        <Grid size={{xs:12}} container  flexDirection="column">
                            <span>Do you currently have any pending visa applications or petitions with USCIS ?<small>*</small></span>
                            <p>Yes</p>
                        </Grid>
                        <Grid size={{xs:12}} container  flexDirection="column">
                            <span>Have you experienced the issue of Requests for evidence (RFE) ?<small>*</small></span>
                            <p>Yes</p>
                        </Grid>
                        <Grid size={{xs:12}} container  flexDirection="column">
                            <span>Have you ever faced any legal issues related to your immigration status (e.g., overstays, unauthorized employment) ?<small>*</small></span>
                            <p>Yes</p>
                        </Grid>
                        <Grid size={{xs:12}} container  flexDirection="column">
                            <span>Have you ever had any visa petitions denied or revoked ?<small>*</small></span>
                            <p>Yes</p>
                        </Grid>
                        <Grid size={{xs:12}} container  flexDirection="column">
                            <span>Have you ever faced any legal issues related to your immigration status (e.g., overstays, unauthorized employment) ?<small>*</small></span>
                            <p>Yes</p>
                        </Grid>
                        <Grid size={{xs:12}} container  flexDirection="column">
                            <span>Are you aware of any current or upcoming changes in your visa status that may affect your ability to work in the U.S. ?<small>*</small></span>
                            <p>Yes</p>
                        </Grid>
                        <Grid size={{xs:12}} container flexDirection="column" className="coustom_textarea">
                            <span>Please explain the upcoming changes in your visa status ?</span>
                            <p>Lorem content</p>
                        </Grid>
                        <Grid size={{md:12,xs:12}} container flexDirection="column" className="jobseekerhead pt-4 pb-0 border_botomer">
                            <h3>Consulate and Port of entry Issues</h3>
                        </Grid>
                        <Grid size={{xs:12}} container  flexDirection="column">
                            <span>Have you experienced the issue of 221g during visa stamping ?<small>*</small></span>
                            <p>Yes</p>
                        </Grid>
                        <Grid size={{xs:12}} container  flexDirection="column">
                            <span>Have you experienced a interrogation with CBP officer at any US Port of entry (Airports, Waterways, Roadways)<small>*</small></span>
                            <p>Yes</p>
                        </Grid>
                        <Grid size={{md:12,xs:12}} container flexDirection="column" className="jobseekerhead pt-4 pb-0 border_botomer">
                            <h3>Legal issues in the past</h3>
                        </Grid>
                        <Grid size={{xs:12}} container  flexDirection="column">
                            <span>Do you have any current or past legal disputes with any employers regarding your immigration status or visa sponsorship ?<small>*</small></span>
                            <p>Yes</p>
                        </Grid>
                        <Grid size={{xs:12}} container  flexDirection="column">
                            <span>Have you ever worked for an employer who was involved in any legal issues related to immigration or employment practices?<small>*</small></span>
                            <p>Yes</p>
                        </Grid>
                        <Grid size={{xs:12}} container  flexDirection="column">
                            <span>Have you ever been employed by a company that has faced any legal action or investigation by USCIS, Department of Labor (DOL), or any other federal agency for visa-related violations ?<small>*</small></span>
                            <p>Yes</p>
                        </Grid>
                        <Grid size={{xs:12}} container  flexDirection="column">
                            <span>Were you ever informed by any of your previous employers that they were under investigation or facing legal challenges related to immigration practices?<small>*</small></span>
                            <p>Yes</p>
                        </Grid>
                        <Grid size={{md:12,xs:12}} container flexDirection="column" className="jobseekerhead pt-4 pb-0 border_botomer">
                            <h3>FDNS Site Visits</h3>
                        </Grid>
                        <Grid size={{xs:12}} container  flexDirection="column">
                            <span>Have you ever been involved in an FDNS site visit or audit at any of your previous employers ?<small>*</small></span>
                            <p>Yes</p>
                        </Grid>
                        <Grid size={{xs:12}} container  flexDirection="column">
                            <span>Have you ever been directly interviewed by an FDNS officer ?<small>*</small></span>
                            <p>Yes</p>
                        </Grid>
                        <Grid size={{xs:12}} container  flexDirection="column">
                            <span>Was your role, location, or project ever scrutinized during an FDNS site visit ?<small>*</small></span>
                            <p>Yes</p>
                        </Grid>
                        <Grid size={{md:12,xs:12}} container flexDirection="column" className="jobseekerhead pt-4 pb-0 border_botomer">
                            <h3>H1B Related Questions</h3>
                        </Grid>
                        <Grid size={{xs:12}} container  flexDirection="column">
                            <span>Have you ever had multiple H1B petitions filed on your behalf for the same fiscal year by different employers ?<small>*</small></span>
                            <p>Yes</p>
                        </Grid>
                        <Grid size={{xs:12}} container  flexDirection="column">
                            <span>Have you ever experienced an H1B petition withdrawal or revocation after the lottery due to suspected fraud or misrepresentation by the employer ?<small>*</small></span>
                            <p>Yes</p>
                        </Grid>
                        <Grid size={{xs:12}} container  flexDirection="column">
                            <span>Has your H1B visa ever been revoked or withdrawn by an employer ?<small>*</small></span>
                            <p>Yes</p>
                        </Grid>
                        <Grid size={{md:5.6,sm:5.8,xs:12}} container flexDirection="column">
                            <span>Upload Supporting Documents</span>
                            <p>File.png</p>
                        </Grid>
                        <Grid size={{xs:12}} container flexDirection="column" className="coustom_textarea">
                            <span>Comments</span>
                            <p>Lorem commets</p>
                        </Grid>
                        <Grid size={{sm:12, xs:12}} container justifyContent="space-between" className="mt-2">
                            <button className='registersendbtn2'>Edit</button>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </div>
    </div>
  )
}

export default ImmigrationHistory
